{
	"password": "Password",
	"confirmPassword": "Confirm password",
	"passwordToggle": {
		"show": "Show password",
		"hide": "Hide password"
	}
}
